import { render, staticRenderFns } from "./AdminProductEdit.vue?vue&type=template&id=0cefe9e6"
import script from "./AdminProductEdit.vue?vue&type=script&lang=js"
export * from "./AdminProductEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports